module.exports = __webpack_public_path__ + "static/media/BGRS-movexpert-sm.32f1c4b7.png";